module.exports = __webpack_public_path__ + "img/04-defaul.fbc94039.png";